export const sizes = {
  container: {
    xl: '1432px',
  },
};
